import React from 'react';
import styled from 'styled-components';
import tr from 'locale';

import PullOutPage from 'components/blocks/PullOutPage/';
import LoaderComponent from 'components/LoaderComponent';
import { Row, Col, SectionHeader, H } from '@3divi/baseui';
import GeneratedKeyField from '../../../../modals/GenerateLicenseModal/GeneratedKeyField';
import ActionBlock from '../../../../elements/LicenseInfoList/LicenseActionBlock';
import LicenseInfoList from '../../../../elements/LicenseInfoList';
import LicenseInfoEditable from '../../../../elements/LicenseInfoEditable';

const Content = styled.div`
  padding: 16px 24px 32px;

  @media (max-width: 720px) {
    padding: 16px 16px 32px;
  }
`;

const Section = styled.div`
  padding: 0 0 16px;
  margin: 0 0 0 -16px;
  box-shadow: none;
`;

const ListWrap = styled.div`
  margin-left: 48px;
  border-bottom: 1px solid ${({ theme }) => theme.border.default};
`;

const StyledRow = styled(Row)`
  @media (max-width: 720px) {
    flex-direction: column-reverse;
  }
`;

const ActionWrap = styled.div`
  width: 100%;
`;

function NuitrackGroupKeyInfoView({ header, isLoaded, activationInfo, info, metadata }) {
  return (
    <PullOutPage backUrl={header.backUrl} title={header.title}>
      {!isLoaded && <LoaderComponent />}
      {isLoaded && (
        <Content>
          <H as="h3" padding="8px 0">
            {header.title}
          </H>
          <StyledRow>
            <Col>
              {info && (
                <Section>
                  <SectionHeader title={tr('lic_info')} icon="edit" />
                  <ListWrap>
                    {info.map(el =>
                      el.editKey ? (
                        <LicenseInfoEditable
                          key={el.editKey}
                          editKey={el.editKey}
                          group={el.group}
                          editTextKey={el.editTextKey}
                        />
                      ) : (
                        <LicenseInfoList key={el.text} items={[el]} />
                      )
                    )}
                  </ListWrap>
                </Section>
              )}
              <Section>
                <SectionHeader title={tr('activations_info')} icon="license" />
                <ListWrap>
                  <LicenseInfoList items={activationInfo.items} />
                  <ActionBlock
                    left={activationInfo.action.left}
                    right={
                      <ActionWrap>
                        {activationInfo.action.type === 'GeneratedKeyField' && (
                          <GeneratedKeyField group={activationInfo.action.group} />
                        )}
                      </ActionWrap>
                    }
                  />
                </ListWrap>
              </Section>
              {metadata.length > 0 && (
                <Section>
                  <SectionHeader title={tr('metadata')} icon="info" />
                  <ListWrap>
                    <LicenseInfoList items={metadata} />
                  </ListWrap>
                </Section>
              )}
            </Col>
          </StyledRow>
        </Content>
      )}
    </PullOutPage>
  );
}

export default NuitrackGroupKeyInfoView;
